<template>

  <v-card flat
          :class="{ 'my-1': hover}"
          :elevation="hover ? 6 : 0"
          @mouseenter="hover=true"
          @mouseleave="hover=false"
  >
    <v-card-title class="py-2 font-weight-black">
      Resumen
    </v-card-title>
    <v-card-text>
    <v-row >
      <v-col cols="12" md="6" offset-md="3" class="text-left"
             v-if="$store.getters.orderSystem.order.couponCode &&
        ($store.getters.orderSystem.order.discountRate || $store.getters.orderSystem.order.discountAmount)"
      >
        <coupon-view :order="$store.getters.orderSystem.order"></coupon-view>
      </v-col>

      <v-col cols="12" md="6" offset-md="3" class="text-left">
        <v-card outlined class="summary-card">
          <v-card-text class="pa-0">
            <v-list dense class="summary-list">
              <v-list-item class="summary-item">
                <v-list-item-avatar size="35" class="summary-avatar">
                  <v-icon color="primary" size="20">shopping_cart</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="summary-label">
                    {{ $t('delivery.cart.products') }}:
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action-text>
                  <v-list-item-title class="summary-amount">
                    {{ currencyFormat($store.getters.orderSystem.getPromosAndItemsAmount) }}
                  </v-list-item-title>
                </v-list-item-action-text>
              </v-list-item>

              <v-list-item v-if="$store.getters.orderSystem.isDelivery" class="summary-item">
                <v-list-item-avatar size="35" class="summary-avatar">
                  <v-icon color="orange" size="20">delivery_dining</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="summary-label">
                    {{ $t('delivery.cart.deliveryCost') }}:
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action-text>
                  <v-list-item-title class="summary-amount">
                    {{ currencyFormat($store.getters.orderSystem.getDeliveryCost) }}
                  </v-list-item-title>
                </v-list-item-action-text>
              </v-list-item>

              <v-list-item v-if="$store.getters.orderSystem.getTotalDiscount" class="summary-item discount-item">
                <v-list-item-avatar size="35" class="summary-avatar">
                  <v-icon color="green" size="20">discount</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="summary-label">
                    {{ $t('delivery.cart.discount') }}:
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action-text>
                  <v-list-item-title class="discount-amount">
                    <span v-if="$store.getters.orderSystem.order.discountRate > 0" class="discount-rate">
                      (-{{$store.getters.orderSystem.order.discountRate}}%)
                    </span>
                    <span class="discount-value">-{{ currencyFormat($store.getters.orderSystem.getTotalDiscount) }}</span>
                  </v-list-item-title>
                </v-list-item-action-text>
              </v-list-item>

              <v-divider class="my-2"></v-divider>

              <v-list-item class="summary-item total-item">
                <v-list-item-avatar size="35" class="summary-avatar total-avatar">
                  <v-icon color="white" size="20">payments</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="total-label">
                    {{ $t('delivery.cart.total') }}:
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action-text>
                  <v-list-item-title class="total-amount">
                    {{ currencyFormat($store.getters.orderSystem.getTotalAmountWithDiscount)}}
                  </v-list-item-title>
                </v-list-item-action-text>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
    </v-card-text>

  </v-card>
</template>

<script>

import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";
import CouponView from "@/modules/delivery/components/CouponView/CouponView.vue";

export default {
  name: "OrderReviewTotal",
  components: {CouponView},
  props: {
    enableTotalQuantity: {type: Boolean, default: false},
    showDiscount: {type: Boolean, default: false},
  },
  mixins: [CurrencyMixin],
  data(){
    return {
      hover: false
    }
  }
}
</script>

<style scoped>
.summary-card {
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.summary-list {
  background: transparent;
}

.summary-item {
  padding: 12px 16px;
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

.summary-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
  transform: translateX(2px);
}

.summary-avatar {
  background-color: rgba(0, 0, 0, 0.05) !important;
  border-radius: 50%;
  margin-right: 8px;
}

.summary-label {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #424242 !important;
  line-height: 1.2 !important;
}

.summary-amount {
  font-size: 16px !important;
  font-weight: 600 !important;
  text-align: right;
}

.discount-item {
  background-color: rgba(76, 175, 80, 0.05);

}

.discount-amount {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.discount-rate {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #4caf50 !important;
  opacity: 0.8;
}

.discount-value {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #4caf50 !important;
}

.total-item {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white !important;
  margin: 8px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.total-avatar {
  background: rgba(255, 255, 255, 0.2) !important;
}

.total-label {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: white !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.total-amount {
  font-size: 20px !important;
  font-weight: 800 !important;
  color: white !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.v-divider {
  margin: 8px 16px !important;
  opacity: 0.3;
}

/* Animaciones adicionales */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.summary-item {
  animation: slideIn 0.3s ease-out;
}

.summary-item:nth-child(1) { animation-delay: 0.1s; }
.summary-item:nth-child(2) { animation-delay: 0.2s; }
.summary-item:nth-child(3) { animation-delay: 0.3s; }
.summary-item:nth-child(4) { animation-delay: 0.4s; }
</style>
